import { useState } from 'react';
import { clienteApi } from '../../common/axios';

export default function DiventaCloserModal({ onClose, onSuccess }) {
  const [form, setForm] = useState({
    codice_fiscale: '',
    iban: '',
    intestatario: '',
    password: '',
  });
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      await clienteApi.post('/cliente/diventa-closer', form);
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || err.response?.data?.errors?.iban?.[0] || 'Errore durante la conversione');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black/60 p-4">
      <div className="bg-white rounded-2xl p-6 max-w-md w-full shadow-2xl relative max-h-[90vh] overflow-y-auto">
        <button onClick={onClose} className="absolute top-4 right-4 text-gray-400 hover:text-black">
          ✕
        </button>
        <h2 className="text-xl font-bold mb-2">Diventa Closer Mangitalia</h2>
        <p className="text-sm text-gray-600 mb-4">
          Convertendo il tuo account in <strong>Closer</strong> potrai richiedere l'accredito dei tuoi guadagni referral direttamente sul tuo conto corrente tramite bonifico bancario (soglia minima 25€).
        </p>

        <div className="bg-orange-50 border-l-4 border-orange-400 p-3 mb-6">
          <p className="text-xs text-orange-800 font-medium">
            ⚠️ Attenzione: Questa operazione non è reversibile. Continuerai a poter usare l'account per fare acquisti normalmente e usare il credito al checkout se lo desideri.
          </p>
        </div>

        {error && <div className="bg-red-50 text-red-700 text-sm p-3 rounded-lg mb-4">{error}</div>}

        <form onSubmit={submit} className="space-y-4">
          <div>
            <label className="block text-sm font-medium mb-1">Codice Fiscale *</label>
            <input required type="text" className="w-full border rounded-lg px-3 py-2 text-sm uppercase"
              value={form.codice_fiscale} onChange={e => setForm({ ...form, codice_fiscale: e.target.value.toUpperCase() })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">IBAN *</label>
            <input required type="text" className="w-full border rounded-lg px-3 py-2 text-sm uppercase font-mono"
              placeholder="IT..."
              value={form.iban} onChange={e => setForm({ ...form, iban: e.target.value.replace(/\s/g, '').toUpperCase() })} />
          </div>
          <div>
            <label className="block text-sm font-medium mb-1">Intestatario Conto *</label>
            <input required type="text" className="w-full border rounded-lg px-3 py-2 text-sm"
              value={form.intestatario} onChange={e => setForm({ ...form, intestatario: e.target.value })} />
          </div>
          <hr className="my-2" />
          <div>
            <label className="block text-sm font-medium mb-1">La tua Password *</label>
            <p className="text-xs text-gray-500 mb-1">Per sicurezza, inserisci la password del tuo account per confermare.</p>
            <input required type="password" className="w-full border rounded-lg px-3 py-2 text-sm"
              value={form.password} onChange={e => setForm({ ...form, password: e.target.value })} />
          </div>

          <div className="pt-4 flex justify-end gap-3">
            <button type="button" onClick={onClose} className="px-4 py-2 text-sm font-medium text-gray-600 hover:bg-gray-100 rounded-lg">
              Annulla
            </button>
            <button type="submit" disabled={loading} className="px-4 py-2 bg-[#c78244] text-white text-sm font-medium rounded-lg hover:bg-[#a66a35] disabled:opacity-50">
              {loading ? 'Attivazione...' : 'Conferma e diventa Closer'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
